import AuthService from "./AuthService";
import Constants from "./Constants";

export default {
	async getItems() {
		try {
			let res = await AuthService.axios().get(`${Constants.adminBackend}/categories`);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`获取失败\n${e}`);
			return [];
		}
	},

	async addItem(index, lang, item) {
		try {
			let res = await AuthService.axios().put(
				`${Constants.adminBackend}/categories/${lang}/${index}/${item}`);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`添加失败\n${e}`);
			return {status: "error", message: e}
		}
	},

	async deleteItem(index, lang, item) {
		try {
			let res = await AuthService.axios().delete(
				`${Constants.adminBackend}/categories/${lang}/${index}/${item}`);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`删除失败\n${e}`);
			return {status: "error", message: e}
		}
	}
}